import 'react';
import 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import 'reakit/Paragraph';
import '../Paragraph/styled.js';
import Paragraph from '../Paragraph/index.js';
var Timeline = styled(Box).withConfig({
  displayName: "styled__Timeline",
  componentId: "yjvza4-0"
})(["&{", ";}"], theme('fannypack.Timeline.base'));
var TimelineRow = styled(Box).withConfig({
  displayName: "styled__TimelineRow",
  componentId: "yjvza4-1"
})(["display:flex;position:relative;&:last-child{margin-bottom:0;}&::before{content:'';border:1px solid ", ";position:absolute;height:100%;left:", "rem;margin-top:", "rem;}&:last-child::before{border:0;}"], function (props) {
  return palette(props.lineColor || 'textTint', props.lineColor);
}, space(1), space(5));
var TimelineStep = styled(Box).withConfig({
  displayName: "styled__TimelineStep",
  componentId: "yjvza4-2"
})(["&{", ";}"], theme('fannypack.Timeline.Step.base'));
var TimelineBullet = styled(Box).withConfig({
  displayName: "styled__TimelineBullet",
  componentId: "yjvza4-3"
})(["border-radius:50%;display:inline-flex;flex-shrink:0;height:0.625rem;width:0.625rem;margin-top:", "rem;margin-right:", "rem;z-index:1;&{", ";}"], space(4), space(2), theme('fannypack.Timeline.Bullet.base'));
var TimelineStepHeading = styled(Paragraph).withConfig({
  displayName: "styled__TimelineStepHeading",
  componentId: "yjvza4-4"
})(["margin-top:", "rem;margin-bottom:", "rem;line-height:1.5rem;color:", ";font-weight:", ";&:not(:last-child){margin-top:", "rem;margin-bottom:", "rem;}&{", ";}"], space(2), space(1), function (props) {
  return props.color || palette('text');
}, theme('fannypack.fontWeights.semibold'), space(2), space(1), theme('fannypack.Timeline.StepHeading.base'));
var TimelineStepDetail = styled(Box).withConfig({
  displayName: "styled__TimelineStepDetail",
  componentId: "yjvza4-5"
})(["color:", ";&{", ";}"], function (props) {
  return props.color || palette('text');
}, theme('fannypack.Timeline.StepDetail.base'));
export { Timeline, TimelineBullet, TimelineRow, TimelineStep, TimelineStepDetail, TimelineStepHeading };